import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { StoreProvider } from "@/app/providers/storeProvider";
import { App } from "@/app";

const root = createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <StrictMode>
    <StoreProvider>
      <App />
    </StoreProvider>
  </StrictMode>,
);
